export const brand = {
  name: "OJ's Bistro",
  chefName: "Chef OJ",
  domain: "ojsbistro.com",
  instagramUrl: "https://www.instagram.com/ojs_bistro/",
  linktreeUrl: "https://linktr.ee/Ojsbistro",
  logo: "/assets/ig/5a0c9b5bc0e8851a.jpg",
  markAlt: "OJ's Bistro logo",
  tagline: "Nigerian soul. Global inspiration. Chef-led dining.",
  heroEyebrow: "Chef-led dining, private experiences, and recipes",
  heroTitle: "Come see what's cooking in the Bistro today",
  heroBody: "Chef-led dining, private experiences, and recipes made for real life.",
  quote: "There's nothing like a home-cooked meal to make everyone feel happy and loved.",
  location: "Lagos roots. Texas tables.",
  email: "hello@ojsbistro.com"
};

export const navItems = [
  { label: "Menus", href: "/menus" },
  { label: "Private Chef", href: "/private-chef" },
  { label: "Recipes", href: "/recipes" },
  { label: "Events", href: "/events" },
  { label: "Shop", href: "/shop" }
];
